import _ from 'lodash'
const API_HINT_CONFIG = {
    hint: _.select( '.c-hint' ),
    closer: _.select( '.c-hint__closer' ),
    message: _.select( '.c-hint__message' ),
    timeout: 2000
}
export default API_HINT_CONFIG